import { common } from 'database/db'
import { getItemFromTable } from 'database/queries/common'
import { saveStructureDb } from 'database/queries/structure'
import { dbCurrentEntries } from 'config/constants'
import { call, put, select, takeEvery } from 'redux-saga/effects'
import {
  getStructure,
  getStructureError,
  getStructureSuccess,
} from 'redux/reducers/structureReducer'
import { selectAppOnline } from 'redux/selector'
import getStructureQuery from 'services/structure'
import { StructureDataResponseType } from 'types/structureType'

function* fetchStructureOnline() {
  try {
    const response: StructureDataResponseType = yield call(getStructureQuery)
    yield saveStructureDb(response)
    return response
  } catch (error) {
    throw new Error('Failed to fetch structure from API')
  }
}

function* fetchStructureOffline() {
  try {
    const response: StructureDataResponseType = yield getItemFromTable(
      common,
      'dcaStructure',
      dbCurrentEntries.STRUCTURE,
    )
    return response
  } catch (error) {
    throw new Error('Failed to fetch structure from local database')
  }
}

export function* getStructureSaga() {
  try {
    const isOnline: boolean = yield select(selectAppOnline)
    const structure: StructureDataResponseType = isOnline
      ? yield fetchStructureOnline()
      : yield fetchStructureOffline()
    if (structure) {
      yield put(getStructureSuccess(structure.data))
    } else {
      yield put(getStructureError())
    }
  } catch (error) {
    yield put(getStructureError())
  }
}

export default function* watchStructureSaga() {
  yield takeEvery(getStructure.type, getStructureSaga)
}
